<template>
  <FileUploadField
    name="driversLicenceFront"
    label="Upload front of licence"
    placeholder="Select or drag your file"
    iconType="NameUserCard"
    iconColor="#00D6BF"
    :errors="form.driversLicenceFrontErrors"
    v-model:driversLicenceFront="form.driversLicenceFront"
    @updateFile="(file) => updateFile('driversLicenceFront', file)"
  />

  <FileUploadField
    name="driversLicenceBack"
    label="Upload back of licence"
    placeholder="Select or drag your file"
    iconType="NameUserCard"
    iconColor="#00D6BF"
    :errors="form.driversLicenceBackErrors"
    @updateFile="(file) => updateFile('driversLicenceBack', file)"
  />
</template>

<script setup>
import { ref, watch, computed } from "vue";
import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import useFormValidation from "@/composables/validations/useFormValidation";
import { useIdentityStore } from "@/stores/forms/identityFormStore";

const store = useIdentityStore();
const { validateFileInput } = useFormValidation();
const $emit = defineEmits(["enableSubmitButton"]);
const form = ref({
  driversLicenceFront: [],
  driversLicenceFrontErrors: "",
  driversLicenceBack: [],
  driversLicenceBackErrors: "",
});

const updateFile = (name, file) => {
  const fileValidationErrors = validateFileInput(name, file);

  form.value[name] = file;
  store.updateValue(name, form.value[name]);
  store.updateState(name, fileValidationErrors);
  form.value[`${name}Errors`] = fileValidationErrors;
};

const formHasErrors = computed(() => {
  const anyErrors =
    form.value.driversLicenceFrontErrors !== "" ||
    form.value.driversLicenceBackErrors !== "";
  const anyFieldsEmpty =
    form.value.driversLicenceFront.length === 0 ||
    form.value.driversLicenceBack.length === 0;
  return anyErrors || anyFieldsEmpty;
});

watch(
  () => formHasErrors.value,
  () => {
    $emit("enableSubmitButton", formHasErrors.value);
  },
  { deep: true }
);
</script>
<style lang="scss" scoped></style>
